import React from "react";
import { Col, Grid } from "react-bootstrap";
import icon from "../../img/app_control.png";
import ResultCol from "../ui/ResultCol";
import { Group, User } from "../../utils/types";
import UserListCol from "../ui/UserListCol";

type SyncFormProps = {
  groups: Group[];
  users: User[];
  currentGroup: string;
  currentQuery: string;
  enableDelete: boolean;
  onForward: () => void;
  doFetchUsers: (group: string, query: string) => void;
  doSynchronize: () => void;
  doSelectEnableDelete: (enableDelete: boolean) => void;
  userButtonDisable?: boolean;
  syncButtonDisable?: boolean;
  forwardButtonDisable?: boolean;
};

function SyncForm({
  groups,
  users,
  currentGroup,
  currentQuery,
  enableDelete,
  onForward,
  doFetchUsers,
  doSynchronize,
  doSelectEnableDelete,
  userButtonDisable = false,
  syncButtonDisable = false,
  forwardButtonDisable = false,
}: SyncFormProps) {

  return (
    <Grid>
      <button
        className="rsi-button is-primary"
        style={{ marginTop: "10px" }}
        type="button"
        id="settingButton"
        disabled={forwardButtonDisable}
        onClick={onForward}
      >
        Show Schedule Execution Setting
      </button>
      <Col
        sm={12}
        style={{
          background: "#FFFFFF",
          marginTop: "10px",
          paddingBottom: "10px",
        }}
      >
        <Col sm={12} className="App">
          <h2>
            <img src={icon} className="top-menu-icon" />
            Google Workspace Directory Synchronization
          </h2>
        </Col>
        <UserListCol
          groups={groups}
          disabled={userButtonDisable}
          onFetchUsers={doFetchUsers}
        />
        {users.length !== 0 && (
          <ResultCol
            users={users}
            currentGroup={currentGroup}
            currentQuery={currentQuery}
            disabled={syncButtonDisable}
            onSyncronize={doSynchronize}
            enableDelete={enableDelete}
            onSelectEnableDelete={doSelectEnableDelete}
          />
        )}
      </Col>
    </Grid>
  );
}

export default SyncForm;
